import { createRouter, createWebHistory } from 'vue-router';
import WechatAuth from '@/utils/auth';

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "home" */ '@/views/index/index.vue'),
    meta: { requiresAuth: true }, // 需要登录
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// 全局前置守卫
router.beforeEach((to, _from, next) => {
  // 检查路由是否需要登录
  if (to.meta.requiresAuth) {
    // 检查用户是否已登录
    if (WechatAuth.isLoggedIn()) {
      // 已登录，放行
      next();
    } else {
      // 未登录，直接进入首页，由首页的mounted钩子处理微信授权逻辑
      next();
    }
  } else {
    // 不需要登录的页面，直接放行
    next();
  }
});

export default router;
